import React from 'react'
import { Box, Heading, SimpleGrid, Text } from '@chakra-ui/react'
import { StockData } from '../types'
import { newsStyles } from '../styles'
import NewsItemCard from './NewsItemCard'

interface NewsPanelProps {
  data: StockData
  cardBg: string
}

const NewsPanel: React.FC<NewsPanelProps> = ({ data, cardBg }) => {
  const { news } = data
  const { maxHeight } = newsStyles

  if (!news || news.length === 0) {
    return (
      <Box>
        <Heading as="h3" mb={4} size="md">Latest News</Heading>
        <Text>No news available for this stock.</Text>
      </Box>
    )
  }

  return (
    <Box>
      <Heading as="h3" mb={4} size="md">Latest News</Heading>
      <Box maxHeight={maxHeight} overflowY="auto" pr={2}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {news.map((item, index) => (
            <NewsItemCard 
              bg={cardBg}
              key={`${item.headline}-${index}`} 
              news={item} 
            />
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  )
}

export default NewsPanel
